<div
  class="container flex flex-row lt-md:flex-col justify-between items-start lt-md:justify-start lt-md:items-center"
>
  <div
    class="flex flex-col gap-[20px] justify-start items-start lt-md:order-2 flex-[100%] max-w-[50%] lt-md:flex-1"
  >
    <h2>
      {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.UPGRADE_PACKAGE_BOX.TITLE' | translate }}
    </h2>
    <vi-text>
      {{
        '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.UPGRADE_PACKAGE_BOX.DESCRIPTION'
          | translate
      }}
    </vi-text>
    <ng-container *ngIf="authStore.isCommercialUser$; else buyPackageButton">
      <ng-container *ngIf="!(bookingStore.activeOrCanceledCommercialBasicSubscription$ | async)">
        <ng-container *ngTemplateOutlet="buyPackageButton"></ng-container>
      </ng-container>
    </ng-container>
  </div>
  <img class="lt-md:order-1" src="./assets/img/installer-guy.png" />
</div>

<ng-template #buyPackageButton>
  <button
    mat-raised-button
    color="primary"
    gtm="onGoToPage"
    gtmAction="Redirect to booking page"
    gtmCategory="diagnosticsOverlay"
    (click)="onBuyPackage()"
  >
    <mat-icon>lock</mat-icon>
    <span>{{ 'ACTIVE_ERROR_DETAILS_PAGE.UPGRADE_PACKAGE_BUTTON.TITLE' | translate }}</span>
  </button>
</ng-template>
